import { tickerItems } from "@/mocks/chigua";

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <section id="ticker" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto flex w-full max-w-7xl items-center gap-4 overflow-hidden px-4 py-3 md:px-6">
        <div className="flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 whitespace-nowrap">
          <i className="ri-bard-fill animate-pulse"></i>
          新鲜出炉
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max gap-10">
            {doubled.map((item, idx) => (
              <span key={idx} className="flex items-center gap-2 text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-record-circle-line text-accent-500 text-[10px]"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#latest"
          className="hidden shrink-0 items-center gap-1 text-sm text-foreground-500 transition-colors hover:text-primary-600 sm:flex"
        >
          全部 <i className="ri-arrow-right-s-line"></i>
        </a>
      </div>
    </section>
  );
}